import { useEffect } from 'react'
import { useProfileQuery } from 'v2/pages/settings/queries'
import { getLocalAuth } from 'v2/utils'
import { identifyUser } from 'v2/utils/analytics'
import { useAuth } from './use-auth'

// Identifies the current user to PostHog after login. Waits for the profile query
// to SETTLE so the first call already carries org_auth_id — the stable account/group
// key. Running before it resolved meant identifying twice per page load, and the
// first of those had no account key, which used to fall back to the (non-unique) org
// name as the group key. Gated on `isFetched`, not on the key itself, so a failed
// profile fetch still identifies the person — just without an account group.
export const useIdentifyAnalytics = () => {
  const { userAuthenticated } = useAuth()
  const { data: profileData, isFetched } = useProfileQuery()
  const orgAuthId = profileData?.organizations?.[0]?.org_auth_id

  useEffect(() => {
    if (!userAuthenticated || !isFetched) return
    const user = getLocalAuth()
    identifyUser({
      email: user?.email,
      aomId: user?.aom_uuid,
      authId: orgAuthId,
      name: user?.name,
      roles: user?.roles?.join(','),
      orgName: user?.organization_name,
      region: user?.region,
      accountKey: orgAuthId,
    })
  }, [userAuthenticated, isFetched, orgAuthId])
}
